// Copyright 2008-2011 David Caldwell <david@porkrind.org>, Jim Radford <radford@blackbean.org> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, in_off_color_order=piles.in_off_color_order,
                              up=piles.up, down=piles.down, in_order_by=piles.in_order_by, in_numeric_order=piles.in_numeric_order;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;

solitaire.alternation = class extends pile_game {
    constructor() {
        super()
        this.pile_game_init(...arguments);
        this.decks = 2;
        this.good = new Array(0);
        this.tableau = new Array(0);
        for (var c=1; c<=8; c++)
            this.good.push(new pile_game.generic_foundation("good"+c, this, true));
        for (var c=1; c<=7; c++)
            this.tableau.push(new this.tableau_pile("tableau"+c, this));
        this.deck = new pile("deck", this);
        this.waste = new pile("waste", this);

        this.create_deck(this.deck, this.waste, 1, this.options.redeal);
        this.deck.xoffset = .3/90;
        this.deck.yoffset = .3/131;
    }

    valid_options = { redeal:             option_def("boolean", false, "Allow deck to be turned back over once all cards have been dealt"),
                      alternating_colors: option_def("boolean", true,  "Tableau is built down by alternating suit colors") };

    tableau_pile = class extends pile {
        constructor(div,game) {
            super(div,game);
                this.card_order = game.options.alternating_colors ? in_off_color_order : in_numeric_order;
        }
        accept_stacks = true;
        accept(card) {
                    return (this.pile.length == 0                                    ? 1 : 0) ||
                           (this.pile.length && this.card_order(card[0], this.top()) ? 2 : 0);
        }
        can_drag(index) { return this.pile[index].face == up && in_order_by(this.card_order, this.pile, index); }
        xoffset = 0;
        splice = pile.prototype.splice_and_turn_over;
        // maxstack: 6 + 13;
    };

    deal(deck) {
            this.deck.pile = deck;
            for (var y=0; y<7; y++)
                for (var x=0; x<7; x++) {
                    var c;
                    this.tableau[x].push(c = this.deck.pop());
                    c.face = y&1 ? down : up;
                }
    }

    is_complete() {
            for (var g in this.good)
                if (this.good[g].pile.length != 13)
                    return NOT_COMPLETE;
            return WON;
    }

    score() {
            return this.count_cards_in(this.good);
    }

    complete() {
            return this.complete_generic(this.good, [this.tableau, [this.waste]]);
    }

    layout = grid([{x: +.3}, "good1", "good2",    "good3",    "good4",    "good5",    "good6",    "good7",    "good8"],
                  ["deck", {x: +.3},  "tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6", "tableau7"],
                  [{y: +.3},
                   "waste"]);
}

module.exports = solitaire.alternation;
// Copyright 2008-2011 David Caldwell <david@porkrind.org>, Jim Radford <radford@blackbean.org> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, in_off_color_order=piles.in_off_color_order,
                              up=piles.up, down=piles.down, in_order_by=piles.in_order_by, in_numeric_order=piles.in_numeric_order;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;

solitaire.alternation = class extends pile_game {
    constructor() {
        super()
        this.pile_game_init(...arguments);
        this.decks = 2;
        this.good = new Array(0);
        this.tableau = new Array(0);
        for (var c=1; c<=8; c++)
            this.good.push(new pile_game.generic_foundation("good"+c, this, true));
        for (var c=1; c<=7; c++)
            this.tableau.push(new this.tableau_pile("tableau"+c, this));
        this.deck = new pile("deck", this);
        this.waste = new pile("waste", this);

        this.create_deck(this.deck, this.waste, 1, this.options.redeal);
        this.deck.xoffset = .3/90;
        this.deck.yoffset = .3/131;
    }

    valid_options = { redeal:             option_def("boolean", false, "Allow deck to be turned back over once all cards have been dealt"),
                      alternating_colors: option_def("boolean", true,  "Tableau is built down by alternating suit colors") };

    tableau_pile = class extends pile {
        constructor(div,game) {
            super(div,game);
                this.card_order = game.options.alternating_colors ? in_off_color_order : in_numeric_order;
        }
        accept_stacks = true;
        accept(card) {
                    return (this.pile.length == 0                                    ? 1 : 0) ||
                           (this.pile.length && this.card_order(card[0], this.top()) ? 2 : 0);
        }
        can_drag(index) { return this.pile[index].face == up && in_order_by(this.card_order, this.pile, index); }
        xoffset = 0;
        splice = pile.prototype.splice_and_turn_over;
        // maxstack: 6 + 13;
    };

    deal(deck) {
            this.deck.pile = deck;
            for (var y=0; y<7; y++)
                for (var x=0; x<7; x++) {
                    var c;
                    this.tableau[x].push(c = this.deck.pop());
                    c.face = y&1 ? down : up;
                }
    }

    is_complete() {
            for (var g in this.good)
                if (this.good[g].pile.length != 13)
                    return NOT_COMPLETE;
            return WON;
    }

    score() {
            return this.count_cards_in(this.good);
    }

    complete() {
            return this.complete_generic(this.good, [this.tableau, [this.waste]]);
    }

    layout = grid([{x: +.3}, "good1", "good2",    "good3",    "good4",    "good5",    "good6",    "good7",    "good8"],
                  ["deck", {x: +.3},  "tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6", "tableau7"],
                  [{y: +.3},
                   "waste"]);
}

module.exports = solitaire.alternation;
